// extracted by mini-css-extract-plugin
export default {"aside":"side_info-module___aside___ffca3f8d","fitContent":"side_info-module___fitContent___b3d080cc"};